import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, user, isLoading } = useAuth();
  
  // 토큰 로딩 중일 때는 리다이렉트하지 않음 (새로고침 시 깜빡임 방지)
  if (isLoading) {
    return null; // 또는 로딩 스피너 표시
  }
  
  // 로그인하지 않은 경우
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // 관리자 권한이 필요한데 없는 경우
  if (requireAdmin && !user?.is_admin) {
    return <Navigate to="/member" replace />;
  }
  
  return <>{children}</>;
};

export default ProtectedRoute;

